<template>
    <section>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <form id="authForm">
                        <h4>{{ signedUp ? 'Signup' : 'Login' }}</h4>
                        <button class="btn btn-danger switch" @click.prevent="switchAuthModeHandler">{{ signedUp ? 'SWITCH TO LOGIN' : 'SWITCH TO SIGNUP' }}</button>
                        <div class="form-group">
                            <label for="useremail">Email address</label>
                            <input v-model="email" type="email" class="form-control" id="useremail" placeholder="enter email">
                        </div>
                        <div class="form-group">
                            <label for="userpassword">Password</label>
                            <input v-model="password" type="password" class="form-control" :class="{danger: password.length < 6}" id="userpassword" placeholder="min length 6">
                        </div>
                        <div class="row">
                            <div class="col">
                                <button v-if="signedUp" type="submit" class="btn btn-success" @click.prevent="signUp">Submit</button>
                                <button v-else type="submit" class="btn btn-success" @click.prevent="logIn">Submit</button>
                            </div>
                        </div>
                        <div class="page-spacer"></div>
                    </form>
                </div>
            </div>
         </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                email: '',
                password: '',
                signedUp: true
            }
        },
        methods: {
            logIn() {
                const authForm = document.querySelector('#authForm');
                auth.signInWithEmailAndPassword(this.email, this.password)
                    .then(cred => {
                        authForm.reset();
                        this.$router.push('/');
                        this.$store.dispatch('setUserId',cred.user.uid);
                        this.$store.dispatch('setLoggedIn',true);
                    }).catch(function(error) {
                        console.log("Error: ", error.message);
                        alert(error.message);
                        authForm.reset();
                    });
            },
            signUp() {
                const authForm = document.querySelector('#authForm');
                auth.createUserWithEmailAndPassword(this.email, this.password)
                    .then(cred => {
                        authForm.reset();
                        this.$router.push('/');
                        this.$store.dispatch('setUserId',cred.user.uid);
                        this.$store.dispatch('setLoggedIn',true);
                    }).catch(function(error) {
                        console.log("Error: ", error.message);
                        alert(error.message);
                        authForm.reset();
                    });
            },
            switchAuthModeHandler() {
                this.signedUp = !this.signedUp;
            }
        },
        created() {
            this.$store.dispatch('updateCurrentPage','auth');
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/Auth.vue